import React from 'react'
import './ProjectVersionTag.sass'

const ProjectVersionTag: React.FC = () => {
    return <span className="version-number">iCOONE Touch Panel - v{process.env.REACT_APP_VERSION}</span>
}

export default ProjectVersionTag
